import { apiCallAdmin } from "../../services/api-service.js";

export const getOrgLogoApi = async () => {
  try {
    const response = await apiCallAdmin("get", "get_org_image");
    return response?.data;
  } catch (err) {
    console.error("Error fetching org logo:", err);
  }
};

export const getProfileDetailsApi = async () => {
  try {
    const response = await apiCallAdmin("get", "basicprofile");
    return response;
  } catch (err) {
    console.error("Error fetching profile details:", err);
    return null;
  }
};
export const updateProfileImageApi = async (data) => {
  try {
    const response = await apiCallAdmin("post", "user/image_update", data);
    return response;
  } catch (err) {
    console.error("Error updating profile image:", err);
  }
};
export const reportAnIssueApi = async (data) => {
  try {
    const response = await apiCallAdmin("post", "report_issue", data);
    return response;
  } catch (err) {
    console.error("Error reporting issue:", err);
  }
};

export const getReportIssueTypeApi = async () => {
  try {
    const response = await apiCallAdmin("get", "get_issue_type");
    return response?.data;
  } catch (err) {
    console.error("Error fetching report issue types:", err);
  }
};

export const getFAQListApi = async () => {
  try {
    const response = await apiCallAdmin("get", "help", null, { params: { application: "Tickgo" } });
    return response?.data;
  } catch (err) {
    console.error("Error fetching FAQ list:", err);
  }
};
export const getOrgListApi = async (application_id) => {
  try {
    const response = await apiCallAdmin("get", `get_enrolled_orgs?application_id=${application_id}`);
    return response;
  } catch (err) {
    console.error("Error fetching org list:", err);
  }
};

export const getSwitchAccountApi = async (id) => {
  try {
    const isHttpsOnly = process.env.REACT_APP_HTTPS_ONLY === "true";
    const endpoint = isHttpsOnly ? `switch_org_http_only/${id}` : `switch_org/${id}`;
    const response = await apiCallAdmin("get", endpoint);
    return response;
  } catch (err) {
    console.error("Error switching account:", err);
  }
};
